<template>
  <div class="random-question-container">
    <div class="title flex-row align-center">
      <span>随机抽题</span>
      <div @click="openRuleDialog()" style="font-size: 14px" class="flex-row align-center ml-10">
        <el-button type="text" icon="el-icon-circle-plus-outline">添加规则</el-button>
        <div class="border_l"></div>
        <span class="setting" title="随机抽题">
          <i class="el-icon-setting" />
          <span class="drawing-item__check" v-if="isSetting">
            <i class="el-icon-check"></i>
          </span>
        </span>
      </div>
    </div>

    <!-- 提示框 -->
    <el-alert class="info-alert" type="warning" :closable="false" :show-icon="false">
      <p>1. 设置题目抽取范围内后，系统自动抽取部分题目在用户侧展示</p>
      <p>2. 不支持跨题目组建立抽题</p>
      <p>3. 如果题目组中包含了题目关联逻辑，设置随机抽题后可能会导致部分逻辑失效，请仔细检查！</p>
    </el-alert>

    <el-dialog
      title="设置抽题规则"
      class="setting-random-logic"
      :visible.sync="rulesVisible"
      @close="resetForm"
      width="65%"
    >
      <!-- 选择区域 -->
      <el-form label-width="70px" label-position="left" class="question-form">
        <el-row v-for="(ruleItem, index) in rules" :key="index" :gutter="20">
          <el-col :span="7">
            <el-form-item label="从题目">
              <el-select
                @change="getRandomCount(ruleItem)"
                style="width: 100%"
                v-model="ruleItem.beginFormItemId"
                placeholder="请选择"
                filterable
                clearable
              >
                <el-option
                  v-for="questionItem in currenGroupItem.items"
                  :disabled="isDisabledBegin(ruleItem, questionItem)"
                  :key="questionItem.formItemId"
                  :label="computedLabels[questionItem.formItemId]"
                  :value="questionItem.formItemId"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="7">
            <el-form-item label="到题目">
              <el-select
                @change="getRandomCount(ruleItem)"
                style="width: 100%"
                v-model="ruleItem.endFormItemId"
                placeholder="请选择"
                filterable
                clearable
              >
                <el-option
                  v-for="questionItem in currenGroupItem.items"
                  :disabled="isDisabledEnd(ruleItem, questionItem)"
                  :key="questionItem.formItemId"
                  :label="computedLabels[questionItem.formItemId]"
                  :value="questionItem.formItemId"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="10">
            <el-form-item label="随机抽取">
              <el-input @input="validateInput(ruleItem)" v-model="ruleItem.num" class="small-input"></el-input>
              <span>道题目</span>
              <el-button type="text" icon="el-icon-circle-plus-outline" class="add-btn" @click="addRule"></el-button>
              <el-button
                type="text"
                icon="el-icon-remove-outline"
                class="remove-btn"
                @click="removeRule(index)"
              ></el-button>
            </el-form-item>
          </el-col>
        </el-row>
        <el-empty v-if="rules.length === 0" description="">
          <div>暂无数据，<el-button type="text" @click="addRule">点击添加</el-button></div>
        </el-empty>
      </el-form>
      <div class="tips">
        提示：设置抽题范围时请勿设置重复区间，否则题目重复时实际抽题数量与设置数量可能会不一致，请仔细检查！
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="rulesVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmAddRules">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { jsonSimpleClone, deepClone, removeHtmlTag } from '@/utils'
import { updateRandomLogic } from '@/api/project/form'
import { hasNotValueEmpty } from '@/utils/object'
export default {
  props: ['activeGroupId', 'fields', 'formKey'],
  data() {
    return {
      rulesVisible: false,
      fromQuestion: '',
      toQuestion: '',
      rules: [],
      defaultRule: {
        formItemGroupId: '',
        beginFormItemId: '',
        endFormItemId: '',
        num: ''
      },
      currenGroupItem: {},
      isSetting: false,
      saveRule: {}
    }
  },
  computed: {
    computedLabels() {
      if (!this.currenGroupItem || !this.currenGroupItem.items) return {} // 避免空对象报错
      return this.currenGroupItem.items.reduce((acc, item) => {
        acc[item.formItemId] = item.textLabel || removeHtmlTag(item.config?.label || '')
        if (item.questionNumber) {
          acc[item.formItemId] = item.questionNumber + '.' + acc[item.formItemId]
        }
        return acc
      }, {})
    }
  },
  watch: {
    activeGroupId(val) {
      if (val) this.init()
    }
  },
  mounted() {
    this.init()
    // this.rules = this.currenGroupItem.items
  },
  methods: {
    init() {
      const { activeGroupId } = this
      const initData = activeGroupId ? this.fields.find((item) => item.id === activeGroupId) : this.currenGroupItem
      this.currenGroupItem = initData
      if (initData && Array.isArray(initData.randomLogics)) {
        const hasLogics = initData.randomLogics.length > 0
        const clonedLogics = hasLogics ? deepClone(initData.randomLogics) : []

        this.rules = clonedLogics
        this.saveRule = clonedLogics
        this.isSetting = hasLogics
      } else {
        this.rules = []
        this.saveRule = []
        this.isSetting = false
      }
    },
    openRuleDialog() {
      const { isSetting, saveRule } = this
      if (isSetting) this.rules = deepClone(saveRule)
      this.init()
      this.rulesVisible = true
    },
    addRule() {
      const newRuleItem = jsonSimpleClone(this.defaultRule)
      newRuleItem.formKey = this.formKey
      newRuleItem.formItemGroupId = this.currenGroupItem.formItemGroupId
      // 添加规则
      this.rules.push(newRuleItem)
    },
    removeRule(index) {
      this.rules.splice(index, 1)
    },
    resetForm() {
      this.rulesVisible = false
      this.rules = []
    },
    // 获取题目的索引（根据 formItemId 查找）
    getIndex(formItemId) {
      return this.currenGroupItem.items.findIndex((q) => q.formItemId === formItemId)
    },
    // 判断哪些选项在【开始题目】里要禁用
    isDisabledBegin(ruleItem, questionItem) {
      if (!ruleItem.endFormItemId) return false
      return this.getIndex(ruleItem.endFormItemId) < this.getIndex(questionItem.formItemId)
    },

    // 判断哪些选项在【结束题目】里要禁用
    isDisabledEnd(ruleItem, questionItem) {
      if (!ruleItem.beginFormItemId) return false
      return this.getIndex(ruleItem.beginFormItemId) > this.getIndex(questionItem.formItemId)
    },

    getRandomCount(ruleItem) {
      if (!ruleItem.endFormItemId || !ruleItem.beginFormItemId) {
        this.$set(ruleItem, 'num', '')
      } else {
        const count = this.getIndex(ruleItem.endFormItemId) - this.getIndex(ruleItem.beginFormItemId)
        this.$set(ruleItem, 'num', Math.abs(count) + 1)
        this.$set(ruleItem, 'maxCount', Math.abs(count) + 1)
      }
    },
    // 计算最多抽取N道题目
    validateInput(ruleItem) {
      let intValue = Number(ruleItem.num)
      const count = Math.abs(this.getIndex(ruleItem.endFormItemId) - this.getIndex(ruleItem.beginFormItemId)) + 1
      // 随机抽题数量只能大于0 且小于 开始题目与结束题目之间的最大值
      const isOverMax = intValue > count
      if (!Number.isInteger(intValue) || intValue < 1 || isOverMax) {
        this.$set(ruleItem, 'num', isOverMax ? count : '')
      } else {
        console.log('输入正确')
      }
    },
    // 选择变更时重新计算禁用状态
    updateOptions() {
      this.$forceUpdate() // 触发视图更新
    },
    async confirmAddRules() {
      if (!hasNotValueEmpty(this.rules, ['logicld'])) {
        return this.$message.error('请检查规则是否填写完整')
      }
      await updateRandomLogic(this.formKey, this.currenGroupItem.formItemGroupId, this.rules)
      this.$message.success('添加成功')
      this.rulesVisible = false
      this.isSetting = this.rules.length > 0
      this.saveRule = deepClone(this.rules)
      this.$emit('getProjectList')
    }
  }
}
</script>

<style lang="scss" scoped>
.title {
  font-size: 14px;
  display: flex;
  align-items: center;
}

.dashed-line {
  font-size: 14px;
  border-top: 1px dashed #ccc;
  margin: 15px 0 10px;
}

.add-rule {
  cursor: pointer;
  margin-left: 10px;
}

.info-alert {
  background: #fdf6ec;
  color: #e6a23c;
  padding: 10px;
  border-radius: 4px;
  font-size: 12px;
  margin-bottom: 10px;
}

.question-form .el-form-item {
  margin-bottom: 12px;
}

.small-input {
  width: 120px;
  margin-right: 6px;
}

.add-btn,
.remove-btn {
  font-size: 16px;
  margin-left: 5px;
}

::v-deep {
  .el-button {
    font-size: 14px;
  }
  .el-icon-remove-outline {
    color: #f56c6c;
  }
  .el-form-item__label {
    font-weight: 400;
    color: #25262b;
  }
  // 设置按钮
  .setting {
    font-size: 14px;
    display: inline-block;
    position: relative;
  }
  .border_l {
    height: 14px;
    border-left: 1px solid #ccc;
    margin: 0 5px;
  }
  .drawing-item__check {
    position: absolute;
    font-size: 5px;
    background: #5dc976;
    color: #fff;
    width: 7px;
    height: 7px;
    line-height: 7px;
    border-radius: 50%;
    left: 10px;
    bottom: 1px;
  }

  .setting-random-logic {
    .question-form {
      min-height: 442px;
      max-height: 485px;
    }
    .tips {
      font-size: 12px;
      color: #909399;
      text-align: left;
      line-height: 1;
      border-top: 1px solid #e1e4eb;
      padding-top: 12px;
    }
  }
}
</style>
